function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fillRule: "nonzero",
  d: "M6.493 0H2.311C1.013 0 .031.977 0 2.2l.001.142.011.144c.121 1.141 1.067 1.995 2.3 1.995h2.436l3.669 11.388.006.04c.236.944 1.14 1.591 2.14 1.591h11.61c.942 0 1.698-.49 2.12-1.304l3.127-5.426.058-.089.111-.197.202-.38c.077-.148.13-.304.16-.464.495-2.71-2.82-3.626-4.371-1.415l-.133.194-.23.36-.177.283-.403.677-.228.392-.647 1.14-.967 1.746h-8.477L8.761 1.625C8.331.58 7.563 0 6.493 0z",
  transform: "translate(-1163 -1756) translate(1163.103 1756)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.765 18.809c2.017 0 3.56 1.633 3.56 3.5 0 1.983-1.543 3.5-3.56 3.5-1.898 0-3.44-1.517-3.44-3.5 0-1.867 1.542-3.5 3.44-3.5z",
  transform: "translate(-1163 -1756) translate(1163.103 1756) rotate(.2 11.825 22.309)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.216 18.809c1.984 0 3.5 1.633 3.5 3.5 0 1.983-1.516 3.5-3.5 3.5-1.866 0-3.5-1.517-3.5-3.5 0-1.867 1.634-3.5 3.5-3.5z",
  transform: "translate(-1163 -1756) translate(1163.103 1756) rotate(.2 20.216 22.309)"
}))));

var SvgIconBasket = function SvgIconBasket(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 27,
    viewBox: "0 0 29 27",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconBasket, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-basket.8b015c76.svg";
export { ForwardRef as ReactComponent };